import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { UtilityService } from '../modules/product-profile/common/utility.service';
import { MessageService } from 'primeng/api';

@Injectable()
export class BenefitcalculatorInterceptor implements HttpInterceptor {
  token: string | null = null;
  accessToken: any;
  constructor(private router: Router, private utilityService: UtilityService, private messageService: MessageService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.token = sessionStorage.getItem('Token') || null;
    this.accessToken = this.token ? JSON.parse(this.token) : null;
    if (this.token) {
      if (!request.url.includes('CompanyLogo') && !request.url.includes('us_states') ) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${this.accessToken}`,
            'Content-Type': 'application/json'
          }
        })
      }
    }
    return next.handle(request).pipe(
      catchError((err) => {
        if (err instanceof HttpErrorResponse) {
          // console.log('err', err);
          if (err.status === 401) {
            sessionStorage.clear();
            this.messageService.add({ key: 'tc', severity: 'error', summary: 'Error', detail: 'Session expired, please login again.' });
            this.router.navigate(['/auth/login']);
          }else if(err.status === 500){
            this.utilityService.setLoader(false);
            this.messageService.add({ key: 'tc', severity: 'error', summary: 'Error', detail: 'Internal server error, please try again later.' });
          }
        }
        return throwError(err);
      })
    )
  }
}
